module.exports = __webpack_public_path__ + "static/BackgroundRock-a1f36aecfc85f0f30240134578765802.png";